<template>
  <div class="participant-wrap">
    <div class="par-content">
      <div class="par-content-left">
        <div class="search-content">
          <el-input
            class="top-search"
            prefix-icon="icon iconfont iconicon_search1"
            v-model="searchInput"
            size="mini"
            placeholder="搜索成员"
            clearable
          ></el-input>
          <div class="no-list" v-if="searchInput && searchList.length === 0">
            暂无数据
          </div>
          <el-cascader-panel
            ref="panel"
            v-if="!searchInput"
            placeholder="请选择成员"
            v-model="selectItems"
            :show-all-levels="false"
            :options="taskMemberlist"
            collapse-tags
            :props="{ multiple: true, emitPath: false }"
            clearable
            @change="onChange"
          >
          </el-cascader-panel>
          <div v-else class="el-cascader-menu__wrap el-scrollbar__wrap" style="margin-bottom: -4px; margin-right: -4px;">
            <ul class="el-scrollbar__view el-cascader-menu__list">
              <li
                role="menuitem"
                id="cascader-menu-4908-1-0"
                tabindex="-1"
                class="el-cascader-node"
                :class="{'is-active': getSelect(item.uid)}"
                v-for="(item) in searchList"
                :key="item.uid"
                @click="addItem(item.uid)"
              >
                <div class="el-checkbox" :class="{'is-checked':getSelect(item.uid)}">
                  <span class="el-checkbox__input" :class="{'is-checked':getSelect(item.uid)}">
                    <span class="el-checkbox__inner"></span>
                    <input type="checkbox" aria-hidden="false" class="el-checkbox__original" value="">
                  </span>
                </div>
                <span class="el-cascader-node__label">{{item.realname}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="par-content-right">
        <div class="checked-list">
          <div class="checked-item" v-for="uid in selectItems" :key="uid">
            <div class="flex">
              <Myavatar width="30px" height="30px" :imgUrl="getItem(uid).user_avatar" :userName="getItem(uid).realname"></Myavatar>
              {{getItem(uid).realname}}
            </div>
            <i class="icon iconfont iconicon_delete" @click="removeChecked(uid)"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="par-bottom">
      <wf-button @click="clearPanel" plain type="danger">清空</wf-button>
      <div class="par-bottom-btns">
        <wf-button @click="close" plain style="margin-right:10px;">取消</wf-button>
        <wf-button type="primary" @click="confirm">保存</wf-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    // selectedData: {
    //   type: Array,
    //   default: []
    // },
    taskMemberlist: {
      type: [Object, Array],
      default: () => {return []}
    }
  },
  data() {
    return {
      selectItems: [], // 选择项
      loading: false, // 加载动画
      searchInput: '',
      localList: [],
      selectData: [],
      tpData: [],
    }
  },
  watch: {
    // selectedData: {
    //   handler: function (value) {
    //     this.selectItems = JSON.parse(JSON.stringify(this.selectedData || []))
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  created() {

  },
  computed: {
    getItem() {
      return uid => {
        let arr = []
        this.taskMemberlist.map(res => {
          if(res.children && res.children.length > 0){
            arr.push(...res.children)
          }
        })
        return arr.find(res => res.uid == uid) || {}
      }
    },
    getSelect() {
      return uid => {
        return this.selectItems.find(res => res == uid) ? true : false
      }
    },
    searchList() {
      if (!this.searchInput) {
        return []
      }
      let arr = []
      this.taskMemberlist.map(res => {
        if(res.children && res.children.length > 0){
          arr.push(...res.children)
        }
      })
      let data = arr.map(res => {
        return res.realname.indexOf(this.searchInput) > -1 ? res : ''
      }).filter(res => res) || []
      return JSON.parse(JSON.stringify(data))
    }
  },
  methods: {
    // 移除选中的选项
    removeChecked(item) {
      let node = this.$refs.panel.getCheckedNodes().find(node => {
        return node.value == item
      })
      if (!node) return
      node.doCheck(false)
      this.$refs.panel.calculateMultiCheckedValue()
    },
    // 关闭
    close() {
      this.$emit("close")
    },
    confirm() {
      this.$emit("confirm", this.selectItems)
    },
    clearPanel() {
      this.selectItems = []
    },
    addItem(uid) {
      console.log(uid, this.selectItems, 111)
      let fl = this.selectItems.indexOf(uid)
      if (fl > -1) {
        this.selectItems.splice(fl, 1)
      } else {
        this.selectItems.push(uid)
      }
    },
    onChange(){
      // console.log('----------------', this.selectItems)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-cascader-menu__wrap {
    height: 100%;
    max-height: 100%;
  }
  .el-cascader-node.is-active{
    color:initial;
  }
  .el-cascader-node.in-active-path{
    color: initial;
  }
}
.participant-wrap {
  padding: 10px;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  .par-top {
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    border-bottom: 1px solid #e6e6e6;
    .close {
      cursor: pointer;
    }
  }
  .par-content-left {
    margin-right: 20px;
  }
  .par-content {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    border-bottom: 1px solid #e6e6e6;
  }
  .search-content {
    width: 360px;
    max-height: 300px;
    .group-box {
      padding-top: 10px;
      overflow: auto;
    }
  }
  .checked-list {
    width: 260px;
    height: 300px;
    border: 1px solid #e6e6e6;
    overflow: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    .checked-item {
      cursor: pointer;
      padding: 0 16px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      i {
        cursor: pointer;
        display: none;
        color: #ff3939;
      }
      .flex {
        display: flex;
        align-items: center;
      }
      .avatar-box {
        margin-right: 15px;
      }
    }
    .checked-item:hover {
      box-shadow: 0 0 8px 2px #eee;
    }
    .checked-item:hover > i {
      display: inline-block;
    }
  }
  .search-content {
    display: flex;
    flex-direction: column;
  }
  .colleagues-list {
    padding: 5px;
    display: block;
    margin-left: 0;
  }
  .search-content .colleagues-list .el-checkbox__label {
    display: flex;
  }
  .par-bottom {
    padding: 15px 0 0;
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .check-info {
    display: flex;
    align-items: center;
  }
  .check-info .avatar-box {
    margin-right: 20px;
  }
  .el-cascader-panel {
    margin-top: 10px;
    height: 257px;
  }
  .no-list {
    margin-top: 10px;
  }
  .is-disabled {
    opacity: 0.4;
    * {
      cursor: not-allowed;
    }
  }
}
</style>
